import { useMemo } from 'react'

import type { RoleResponse } from '@api'
import { type UseQueryOptions, useQuery } from 'react-query'

import { teamService } from '../service/team-service'
import type { TeamRole } from '../types'

export const useRoles = (
  searchValue?: string | null,
  queryOptions?: UseQueryOptions<RoleResponse[], unknown>,
) => {
  const query = useQuery<RoleResponse[]>(
    ['team', 'roles'],
    teamService.getTeamRoles,
    queryOptions,
  )

  const rolesSortedByDefault = useMemo(
    () =>
      query.data?.sort((a, b) =>
        a.isDefault === b.isDefault ? 0 : a.isDefault ? 1 : -1,
      ),
    [query.data],
  )

  const filteredRoles = useMemo(() => {
    if (!rolesSortedByDefault || !searchValue) {
      return rolesSortedByDefault
    }

    return rolesSortedByDefault.filter((role) =>
      role.name.toLowerCase().includes(searchValue.toLowerCase()),
    )
  }, [rolesSortedByDefault, searchValue])

  return {
    ...query,
    data: filteredRoles,
  }
}
